module.exports = __webpack_public_path__ + "static/img/LifeatDito2b.f54ddbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hr/LifeatDito2b.png
// module id = R2ID
// module chunks = 2